import { render, staticRenderFns } from "./_pageId.vue?vue&type=template&id=afae8350&scoped=true&"
import script from "./_pageId.vue?vue&type=script&lang=js&"
export * from "./_pageId.vue?vue&type=script&lang=js&"
import style0 from "./_pageId.vue?vue&type=style&index=0&id=afae8350&prod&lang=scss&scoped=true&"
import style1 from "./_pageId.vue?vue&type=style&index=1&id=afae8350&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afae8350",
  null
  
)

export default component.exports